import { FC } from 'react';
import { cvaRoot } from './PageHeaderStyles';
import { Container } from '@/shared/ui/Container';
import { VariantProps } from 'class-variance-authority';

interface Props extends VariantProps<typeof cvaRoot> {
  children: React.ReactNode;
}

const PageHeader: FC<Props> = ({ children, pt, pb }) => {
  return <Container className={cvaRoot({ pt, pb })}>{children}</Container>;
};

export default PageHeader;
